<template>
  <SubNavCardVue :buttons="buttons" />
</template>

<script>
import SubNavCardVue from "../../components/cards/SubNavCard.vue";

export default {
  components: { SubNavCardVue },
  data() {
    return {
      buttons: [
        {
          label: "Stock",
          icon: "bi bi-database-fill-check",
          route: "stocks-index",
        },
        {
          label: "Rupture de stock",
          icon: "bi bi-database-fill-exclamation",
          route: "stocks-out-index",
        },
        {
          label: "Transfert quantité",
          icon: "bi bi-arrow-left-right",
          route: "stocks-transfer-quantity",
        },
        {
          label: "Statistiques inventaire",
          icon: "bi bi-clipboard2-data-fill",
          route: "stocks-statistics-index",
        },
        {
          label: "Désignations",
          icon: "bi bi-tags-fill",
          route: "stocks-designations-index",
        },
        {
          label: "Nouvelle désignation",
          icon: "bi bi-tag-fill",
          route: "stocks-designations-create",
        },
      ],
    };
  },
};
</script>
